import { h } from 'preact';

import { Trans } from '@lingui/macro';

export const AlignMenu = () => (
	<a href={'#/align'}><Trans>Align</Trans></a>
);
